import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { Select, Store } from "@ngxs/store";
import { Observable } from "rxjs";
import { GlobalStateModel } from "../../shared/model/global.model";
import { BioSeal } from "../../shared/model/bioseal.model";
import { GlobalState } from "../../shared/store/state/global.state";
import { BioSealState } from "../../shared/store/state/bioseal.state";

import { ConfigurationSandbox } from "../../shared/sandbox/providers/configuration.sandbox";
@Component({
  selector: "id3-configuration-menu",
  templateUrl: "./configuration-menu.component.html",
  styleUrls: ["./configuration-menu.component.css"],
  providers: [ConfigurationSandbox],
})
export class ConfigurationMenuComponent implements OnInit {
  @Select(GlobalState.getGlobal) global: Observable<GlobalStateModel>;
  @Select(BioSealState.getBioSealData) bioseal: Observable<BioSeal>;
  isDisabled: Boolean = false;

  @Output() nextEvent = new EventEmitter<boolean>();
  @Output() previousEvent = new EventEmitter<boolean>();

  constructor(public configurationSandbox: ConfigurationSandbox) { }

  ngOnInit(): void { }


  next(): void {
    this.nextEvent.emit();
  }

  previous(): void {
    this.previousEvent.emit();
  }

}
